<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Payroll Runs</h1>
    <p>Does your payroll have the requirement to process multiple payrolls within one month? For example, do you have both a weekly and monthly payroll, or offset monthly payrolls.</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasMultiplePayrollsInPeriod">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasMultiplePayrollsInPeriod">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref,  } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasMultiplePayrollsInPeriod === undefined || props.formData.hasMultiplePayrollsInPeriod === null || props.formData.hasMultiplePayrollsInPeriod === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}



const executeStep = async () => {
  return true;
}



defineExpose({ validateStep, executeStep });

</script>